(function () {
    'use strict';

    function mailRequestDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/mailrequest/';


        function contactAccountManager(data) {
            return $http.post(baseUrl + 'contactaccountmanager', data).then(
                function (response) {
                    return true;
                });
        }

        function contactAllAccountManagers(data) {
            return $http.post(baseUrl + 'contactallaccountmanagers', data).then(
                function (response) {
                    return true;
                });
        }

        function sendProjectReminder(projectId) {
            return $http.post(baseUrl + 'projectreminder/' + projectId, {}).then(
                function (response) {
                    return true;
                });
        }

        function sendPremiumUpgradeRequest(data) {
            return $http.post(baseUrl + 'sendpremiumupgraderequest', data).then(
                function (response) {
                    return true;
                });
        }

        function sendWorkflowSharingUpdate(data) {
            return $http.post(baseUrl + 'sendworkflowsharingupdate', data).then(
                function (response) {
                    return true;
                });
        }

        function sendWorkflowUpdate(data) {
            return $http.post(baseUrl + 'sendworkflowupdate', data).then(
                function (response) {
                    return true;
                });
        }

        function sendConnectionRequest(data) {
            return $http.post(baseUrl + 'sendconnectionrequest', data).then(
                function (response) {
                    return true;
                });
        }

        function sendPublishedUpdate(data) {
            return $http.post(baseUrl + 'sendpublishedupdate', data).then(
                function (response) {
                    return true;
                });
        }

        function sendRequestForProposalResponseCreated(data) {
            return $http.post(baseUrl + 'sendrequestforproposalresponsecreated', data).then(
                function (response) {
                    return true;
                });
        }

        function sendRequestForProposalResponseUpdate(data) {
            return $http.post(baseUrl + 'sendrequestforproposalresponseupdate', data).then(
                function (response) {
                    return true;
                });
        }

        function sendRequestForProposalRespondentUpdate(data) {
            return $http.post(baseUrl + 'sendrequestforproposalrespondentupdate', data).then(
                function (response) {
                    return true;
                });
        }

        return {
            contactAccountManager: contactAccountManager,
            contactAllAccountManagers: contactAllAccountManagers,
            sendProjectReminder: sendProjectReminder,
            sendPremiumUpgradeRequest: sendPremiumUpgradeRequest,
            sendWorkflowSharingUpdate: sendWorkflowSharingUpdate,
            sendWorkflowUpdate: sendWorkflowUpdate,
            sendConnectionRequest: sendConnectionRequest,
            sendPublishedUpdate: sendPublishedUpdate,
            sendRequestForProposalResponseCreated: sendRequestForProposalResponseCreated,
            sendRequestForProposalResponseUpdate: sendRequestForProposalResponseUpdate,
            sendRequestForProposalRespondentUpdate: sendRequestForProposalRespondentUpdate
        }
    }

    mailRequestDataService.$inject = ['$http'];

    angular.module('ecap.common').service('mailRequestDataService', mailRequestDataService);
})();
